import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate} from 'react-router-dom';
import {pdpUrlTypeState} from 'Utilities';

const UrlGeneratorPdp = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [timeOuts, setTimeouts] = useState(null);
    const [urlGenDataArr, setUrlGenDataArr] = useState([]);
    
    const generateNewUrl = (currentData) => {
    let data = [currentData];
    const sortedData = data?.sort()?.[0];
    let newData = [];

    for (let key in sortedData) {
        const value = sortedData[key];
        if (value?.length) {
            newData.push({ 
                key,
                value: `${value}` === '[object Object]' ? JSON.stringify(value) : `${value}` 
            });
        }
    }

    const nextQueryObj = {};
    let stringData = "";

    newData.forEach((item, ind) => {
        const encodedKey = item.key
            ?.replaceAll("&", "ANDAND")
            ?.replaceAll("#", "HASH")
            ?.replaceAll("/", "SLASH");
        const encodedVal = item.value
            ?.replaceAll("&", "ANDAND")
            ?.replaceAll("#", "HASH")
            ?.replaceAll("/", "SLASH");
        
        nextQueryObj[encodedKey] = encodedVal;

        stringData += `${encodedKey}=${encodedVal}${ind !== newData.length - 1 ? "&" : ""}`;
    });

    // Parse current URL params
    const currentParams = {};
    location.search?.slice(1)?.split("&")?.forEach(pair => {
        const [k, v] = pair.split("=");
        if (k && v) currentParams[k] = v;
    });

    // Compare next and current key-values
    const isEqual = Object.keys(nextQueryObj).length === Object.keys(currentParams).length &&
        Object.keys(nextQueryObj).every(k => currentParams[k] === nextQueryObj[k]);

    if (isEqual) return; // nothing changed, exit

    // Debounced navigate
    if (timeOuts) {
        clearTimeout(timeOuts);
        setTimeouts(null);
    }

    const to = setTimeout(() => {
        navigate({
            search: stringData !== "" ? `?${encodeURI(stringData)}` : location?.search,
            state: pdpUrlTypeState
        }, { replace: false });
        setTimeouts(null);
    }, 240);
    
    setTimeouts(to);
};
    useEffect(() => {
        // const urlSearch = location?.search?.slice(1)?.replaceAll("HASH", "#")
        const urlSearch = location?.search?.slice(1)
    ?.replaceAll("HASH", "#")
    ?.replaceAll("SLASH", "/");

        const urlData = urlSearch?.split("&");

        let data = {};
        if (urlData?.[0] !== '') {
            urlData?.forEach((item, ind) => {
                const key = item?.split("=")?.[0], value= item?.split("=")?.[1];
                const key1 =key? key.replaceAll("ANDAND","&"):""
                if(key1 && value ) data[decodeURI(key1)] = decodeURI(value);
            });
        }
        setUrlGenDataArr(data);
    }, [location?.search]);

    const urlGenData = useMemo(()=> urlGenDataArr,[urlGenDataArr])

    return { urlGenData, generateNewUrl };
}

export default UrlGeneratorPdp;
